export default "/fonts/Muli-ExtraBold.ttf?e59a298dcd54ab53886b35c11df05869";